import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '新版模件',
    type: 'ISRFREQ_TARMODULE',
}
